import { Helper } from "../../../dev/utils/Helper";
import { Bounce,gsap } from "gsap";
import { TextStyleOptions, BitmapTextStyleOptions } from '../../../dev/setting/text/IText';
import { FontStyle, FontWeight } from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import { GameAssets } from '../../config/texture/GameAssets';

export class RoadRageSymbolMultiplier extends PIXI.Container {

    private readonly _multStyle: TextStyleOptions = {
        fontFamily: "Helvetica",
        fontStyle: FontStyle.ITALIC,
        fontWeight: FontWeight.EXTRA_BOLD,
        dropShadow: true,
        dropShadowAngle: 8,
        dropShadowBlur: 8,
        dropShadowDistance: 12,
        fill: [
            "#ffffff",
            "#FFFC00"
        ],
        fontSize: 42,
        miterLimit: 0,
        wordWrap: true,
        wordWrapWidth: 500,
        stroke: "#FF6A00",
        strokeThickness: 2
    };

    private readonly _multStyleShadow: TextStyleOptions = {
        fontFamily: "Helvetica",
        fontStyle: FontStyle.ITALIC,
        fontWeight: FontWeight.EXTRA_BOLD,
        dropShadow: true,
        dropShadowAngle: 8,
        dropShadowBlur: 8,
        dropShadowDistance: 12,
        fill: "#000000",
        fontSize: 42,
        miterLimit: 0,
        wordWrap: true,
        wordWrapWidth: 500,
        stroke: "#000000",
        strokeThickness: 2
    };

    private readonly _style: BitmapTextStyleOptions = {
        fontName: GameAssets.BITMAP_FONT_MULTIPLIER,
        fontSize: 30,
        align:"center"
    };

    private _timeLine:gsap.core.Timeline;
    private _currentSymbolHeight:number;
    private _multText:PIXI.BitmapText;
    private _multShadowText:PIXI.BitmapText;

    public get currentValue():number{
        return parseFloat(this._multText.text.split("x")[0]);
    }

    constructor(amount:number, symbolHeight:number) {
        super();

        this._currentSymbolHeight = symbolHeight;

        this._multText = this.addChild(new PIXI.BitmapText(amount+"x",this._style))
        this._multShadowText = this.addChild(new PIXI.BitmapText(amount+"x",this._style))

        this._multShadowText.tint = 0x555555;
        this._multShadowText.alpha = 0;
    }
    
    // createText(amm:number):PIXI.Text{
    //     const txt:PIXI.Text =  this.addChild(new PIXI.Text(amm+"",this._multStyle));
    //     txt.anchor.set(0.5,0.5);
    //     return txt;
    // }

    setShadowAlpha( alpha: number = 0.35): void {
        this._multShadowText.alpha = alpha;
    }

    private darnkessTL:gsap.core.Timeline;
    shadowAlpha(enable: boolean, alpha: number = 0.35, durr:number = 0.25): void {
        this.darnkessTL = Helper.setTimeline(this.darnkessTL, new gsap.core.Timeline(), true);
        this.darnkessTL.to(this._multShadowText, { duration: durr, alpha: enable ? alpha : 0 });
    }

    playWin(durr:number = 0.25): gsap.core.Timeline {
        this._timeLine = Helper.setTimeline(this._timeLine, new gsap.core.Timeline(), true);
        this._timeLine.fromTo(this.scale, { x: 1.15, y: 1.15, }, { x: 1, y: 1, duration: durr , ease: Bounce.easeOut }, 0)
        return this._timeLine;
    }
  
    setValue(multValue: number = 1, durr:number = 0.25, symbolHeight:number = this._currentSymbolHeight): gsap.core.Timeline {
        this._timeLine = Helper.setTimeline(this._timeLine, new gsap.core.Timeline(), true);

        // if(this.currentValue === multValue){

            this._multText.text = multValue+"x";
            this._multShadowText.text = multValue+"x";
            this._currentSymbolHeight = symbolHeight;
    
            const dirrXScale:number = this.scale.x; 
    
            this._timeLine.fromTo(this.scale, { x: dirrXScale * 1.15, y:  1.15, }, { x:dirrXScale * 1, y: 1, duration: durr , ease: Bounce.easeOut }, 0)
        // }

        return this._timeLine;
    }

    Stop(duration: number) {
        this._timeLine = Helper.setTimeline(this._timeLine, new gsap.core.Timeline({ onComplete: () => {this.visible = false }}), true);
        this._timeLine.fromTo(this, { alpha: 1 }, { alpha: 0, duration: duration }, 0);
    }

    remove(): void {
        if (this._timeLine) this._timeLine.totalProgress(1);
        this.destroy({ children: true });
    }
}